import { LogoIcon } from "@volca/ui/components/ui/logo";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";

export const LoadingPayout = () => (
  <Stack
    align="center"
    className="m-auto h-full min-h-screen w-full max-w-md bg-surface-raised p-8"
    gap={8}
  >
    <LogoIcon />
    <Spinner
      layout="centered"
      className="h-40"
      aria-label="Loading credit payment"
    />
  </Stack>
);
